export default "__VITE_ASSET__d0dfdd46__"